import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';

import { AnalyticsService } from './analytics.service';

export class HttpErrorInterceptor implements HttpInterceptor {
  analytics = inject(AnalyticsService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse) {
          this.analytics.error('HTTP Request Error', error);
        }
        return throwError(() => error);
      }),
    );
  }
}
